import { Layers } from "lucide-react";
import { SubBrandMetrics } from "@/components/ai-consumer-research/sub-brands/metrics";
import { Products } from "@/components/ai-consumer-research/sub-brands/products";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/consumer-research/_layout/sub-brands")({
  component: SubBrands,
});

export function SubBrands() {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <span className="flex size-9 items-center justify-center rounded-lg bg-muted">
        <Layers className="size-5" strokeWidth={2.5} />
        </span>
        <h2 className="text-2xl font-semibold">Sub-Brands</h2>
      </div>
      <SubBrandMetrics />
      <Products />
    </div>
  );
}
